import './App.css';

import React, { useEffect, useState } from 'react';
import axios from 'axios';

function App() {

  const url_auth = 'https://login.comune.dianodalba.cn.it';
  const url_to = 'https://www.comune.dianodalba.cn.it/moduli/prenota-appuntamento-1';

  const serialize = (obj) => {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  }

  const [message, setMessage] = useState("Controllo identià in corso...");


  useEffect(() => {
    axios.get( url_auth + '/backend/api/userinfo/', {
      headers: {
          'Content-Type': 'application/json',
      },
      withCredentials: true,
    })
    .then(result => {
      if(result.status === 200){
        console.log(result.data[0]);
        var user = result.data[0];

        setMessage("Ti stiamo reindirizzando sulla pagina del servizio...");
        window.location.href = url_to + "?" + serialize({
          nome: user.first_name,
          cognome: user.last_name,
          codice_fiscale: user.attributes.tax_code,
          telefono: user.attributes.mobile_phone,
          email: user.attributes.email
        });
        
      }else{
        setMessage("Ti stiamo reindirizzando sulla pagina del servizio...");
        window.location.href = url_to;
        /*
        setMessage("Impossibile confermare la tua l'identità.");
        window.location.href = url_auth + "?" + serialize({
          from: window.location.href,
        });
        */
      }
    })
    .catch(error => {
      setMessage("Ti stiamo reindirizzando sulla pagina del servizio...");
      window.location.href = url_to;
      /*
      setMessage("Impossibile confermare la tua l'identità.");
      window.location.href = url_auth + "?" + serialize({
        from: window.location.href,
      });
      */
      
    });
  }, []);

  return (
    <div className="App" style={{ padding: 100 }}>
      {message}
    </div>
  );
}

export default App;
